import Vue from 'vue'
//transformDate
Vue.filter('transformDate', (value, addMinute = 0, short = false) => {
    if (!value) return ''
    if (typeof value !== 'string') return 'String value only!'
    value = Vue.prototype.$generalizeDate(value)
    const now = Vue.prototype.$date()
    let date = Vue.prototype.$date(value).add(addMinute, 'm')
    if (date.isSame(now, 'day')) return date.format('HH:mm')
    if (short) return date.format('HH:mm')
    // British order (tasks#211): "6 Nov, 14:30", the year only when it is not this year
    return date.format(
        date.isSame(now, 'year') ? 'D MMM, HH:mm' : 'D MMM YYYY, HH:mm'
    )
})
